// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ulIY","rootNoMargin":"styles_rootNoMargin__2AyMW"};